import { toast } from "react-toastify";
import { Logout } from "../Components/Auth/isAuthenticated";
import { api } from "./Api";
import { IErroRest, IRest } from "./Interfaces";

// ─── Momentos Compartilhados — fotos institucionais ──────────────────────────
//
// Rotas do admin, sem prefixo de idioma: o roteador carrega src/Controller/Admin
// uma segunda vez sem o /{_locale}, igual a /admin/banner.

export interface IStoryInstitutional {
  id: string;
  imageUrl: string | null;
  caption: string | null;
  likeCount: number;
  viewCount: number;
  isInstitutional: boolean;
  timeAgo: string;
  createdAt: string | null;
  expiresAt: string | null;
}

export interface IRestStoryInstitutionalList {
  data: {
    code: number;
    message: string;
    total: number;
    data: IStoryInstitutional[];
  };
}

export const getInstitutionalStories = async () => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .get(`/admin/story/institutional`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRestStoryInstitutionalList) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    return false;
  }
};

export const postInstitutionalStory = async (formData: FormData) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/admin/story/institutional`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: IRest) => resolve(response))
          .catch((error) => reject(error));
      }),
      {
        success: "Foto institucional cadastrada com sucesso!",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    return false;
  }
};

export const deleteInstitutionalStory = async (id: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .delete(`/admin/story/institutional/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRest) => resolve(response))
          .catch((error) => reject(error));
      }),
      {
        success: "Foto removida.",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    return false;
  }
};